export default "__VITE_ASSET__BWTgnDYP__"